export var SDK_VERSION = '6.2.2';
//# sourceMappingURL=version.js.map